import React, { useState, useEffect } from 'react';

const API = 'https://green-energy.com.co/api';

const rolConfig = {
  admin:    { label:'Admin',        color:'#f87171', bg:'#3a1a1a' },
  operador: { label:'Operador',     color:'#60a5fa', bg:'#1a2a3a' },
  lectura:  { label:'Solo lectura', color:'#4ade80', bg:'#1a3a2a' },
};

export default function AdminUsuarios({ usuario }) {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ nombre:'', email:'', password:'', rol:'lectura', cop:'todos' });
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  const fetchUsuarios = () => {
    fetch(`${API}/usuarios`, { headers: { 'x-user-email': usuario.email } })
      .then(r=>r.json()).then(data=>{ setUsuarios(data); setLoading(false); })
      .catch(()=>setLoading(false));
  };

  useEffect(() => { fetchUsuarios(); }, []);

  const guardarUsuario = async () => {
    if (!form.nombre || !form.email || !form.password) { setMsg({ok:false,txt:'Completa todos los campos'}); return; }
    setSaving(true);
    try {
      const resp = await fetch(`${API}/usuarios`, {
        method: 'POST',
        headers: { 'Content-Type':'application/json', 'x-user-email': usuario.email },
        body: JSON.stringify(form)
      });
      const data = await resp.json();
      if (data.ok) {
        setMsg({ok:true,txt:'Usuario creado correctamente'});
        setShowForm(false);
        setForm({ nombre:'', email:'', password:'', rol:'lectura', cop:'todos' });
        fetchUsuarios();
      } else {
        setMsg({ok:false,txt:data.error||'Error al crear usuario'});
      }
    } catch(e) { setMsg({ok:false,txt:'Error de conexión'}); }
    setSaving(false);
    setTimeout(()=>setMsg(null), 4000);
  };

  const toggleActivo = async (id, activo) => {
    await fetch(`${API}/usuarios/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type':'application/json', 'x-user-email': usuario.email },
      body: JSON.stringify({ activo: activo ? 0 : 1 })
    });
    fetchUsuarios();
  };

  if (loading) return <div style={{padding:'3rem',textAlign:'center',color:'#666'}}>Cargando usuarios...</div>;

  return (
    <div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'1.5rem'}}>
        <div className="page-title" style={{margin:0}}>Administración de usuarios</div>
        <button onClick={()=>setShowForm(!showForm)}
          style={{padding:'8px 18px',background:'#1d6a3a',border:'none',borderRadius:'7px',color:'#fff',cursor:'pointer',fontSize:'13px',fontWeight:'600'}}>
          + Nuevo usuario
        </button>
      </div>

      {msg && (
        <div style={{background:msg.ok?'#1a3a2a':'#3a1a1a',border:`1px solid ${msg.ok?'#4ade80':'#f87171'}`,borderRadius:'8px',padding:'10px 16px',marginBottom:'1.25rem',fontSize:'13px',color:msg.ok?'#4ade80':'#f87171'}}>
          {msg.ok?'✅':'❌'} {msg.txt}
        </div>
      )}

      {/* Formulario nuevo usuario */}
      {showForm && (
        <div className="card" style={{marginBottom:'1.25rem'}}>
          <div className="card-title">Nuevo usuario</div>
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'12px'}}>
            <div>
              <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'4px'}}>Nombre completo</label>
              <input value={form.nombre} onChange={e=>setForm({...form,nombre:e.target.value})} placeholder="Nombre" style={{width:'100%'}} />
            </div>
            <div>
              <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'4px'}}>Correo electrónico</label>
              <input type="email" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder="usuario" style={{width:'100%'}} />
            </div>
            <div>
              <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'4px'}}>Contraseña inicial</label>
              <input type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} placeholder="••••••••" style={{width:'100%'}} />
            </div>
            <div>
              <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'4px'}}>COP</label>
              <select value={form.cop} onChange={e=>setForm({...form,cop:e.target.value})} style={{width:'100%'}}>
                <option value="todos">Todos los COP</option>
                <option value="Fontibón">Solo Fontibón</option>
                <option value="Usme">Solo Usme</option>
              </select>
            </div>
            <div>
              <label style={{fontSize:'12px',color:'#666',display:'block',marginBottom:'4px'}}>Rol</label>
              <select value={form.rol} onChange={e=>setForm({...form,rol:e.target.value})} style={{width:'100%'}}>
                <option value="admin">Admin — acceso total</option>
                <option value="operador">Operador — comandos y monitoreo</option>
                <option value="lectura">Solo lectura — dashboards</option>
              </select>
            </div>
          </div>
          <div style={{display:'flex',gap:'8px'}}>
            <button onClick={guardarUsuario} disabled={saving}
              style={{padding:'8px 20px',background:'#1d6a3a',border:'none',borderRadius:'7px',color:'#fff',cursor:'pointer',fontSize:'13px',fontWeight:'600'}}>
              {saving?'⏳ Guardando...':'✅ Crear usuario'}
            </button>
            <button onClick={()=>setShowForm(false)}
              style={{padding:'8px 16px',background:'#2a2d3a',border:'none',borderRadius:'7px',color:'#aaa',cursor:'pointer',fontSize:'13px'}}>
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Tabla de usuarios */}
      <div className="card">
        <table>
          <thead>
            <tr><th>#</th><th>Nombre</th><th>Correo</th><th>Rol</th><th>COP</th><th>Último acceso</th><th>Estado</th><th>Acciones</th></tr>
          </thead>
          <tbody>
            {usuarios.map(u => {
              const rc = rolConfig[u.rol]||rolConfig.lectura;
              return (
                <tr key={u.id}>
                  <td style={{color:'#555',fontSize:'12px'}}>{u.id}</td>
                  <td style={{fontWeight:'500'}}>{u.nombre}</td>
                  <td style={{color:'#aaa',fontSize:'12px'}}>{u.email}</td>
                  <td><span style={{background:rc.bg,color:rc.color,padding:'2px 8px',borderRadius:'5px',fontSize:'11px',fontWeight:'500'}}>{rc.label}</span></td>
                  <td style={{color:'#aaa',fontSize:'12px'}}>{u.cop}</td>
                  <td style={{color:'#555',fontSize:'12px'}}>{u.last_login?new Date(u.last_login).toLocaleString('es-CO'):'Nunca'}</td>
                  <td>
                    <span style={{background:u.activo?'#1a3a2a':'#2a2a2a',color:u.activo?'#4ade80':'#666',padding:'2px 8px',borderRadius:'5px',fontSize:'11px',fontWeight:'500'}}>
                      {u.activo?'Activo':'Inactivo'}
                    </span>
                  </td>
                  <td>
                    {u.email !== usuario.email && (
                      <button onClick={()=>toggleActivo(u.id, u.activo)}
                        style={{padding:'3px 10px',background:'#2a2d3a',border:'none',borderRadius:'5px',color:'#aaa',cursor:'pointer',fontSize:'11px'}}>
                        {u.activo?'Desactivar':'Activar'}
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
